import React, { useState } from 'react';
import ModalForm from '../Reusable/ModalForm';
import { SubmitButton } from '../../enums/GlobalEnums';
import { ModalForAddOrUpdateBrand } from '../../enums/BrandEnums';

const ModalForAddBrand = ({
  handleAdd,
  handleClose,
  show,
  brandReducer,
}) => {
  const { error } = brandReducer;
  const [initialValues] = useState({ brandName: '' });

  const fields = [
    {
      name: 'brandName',
      label: ModalForAddOrUpdateBrand.brandNamePlaceholder,
      type: 'text',
    },
  ];

  const handleSubmit = (formData) => {
    handleAdd(formData);
  };

  return (
    <ModalForm
      open={show}
      onClose={handleClose}
      title={ModalForAddOrUpdateBrand.titleForAddBrand}
      fields={fields}
      onSubmit={handleSubmit}
      initialValues={initialValues}
      error={error}
      submitLabel={SubmitButton.save}
    />
  );
};

export default ModalForAddBrand;
